import * as consts from '../../constants.js';

export default {
  dataServicesStatus: consts.REQUEST_WITHOUT_STARTING,
  services: [],
};
